import { Injectable } from '@angular/core';
import { ShelfElement } from './shelf-element';
import { SHELF_ELEMENTS } from './shelf-elements';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';

// import './js/ArrayFrom';


@Injectable()
export class ShelfElementService {

  constructor() { }

    getShelfElements(): Observable<ShelfElement[]> {
        return of(SHELF_ELEMENTS);
    }

    getFloorShelfElements(): Observable<ShelfElement[]> {
        const shelfFloorElements = [];
        SHELF_ELEMENTS.forEach(function (shelfElement) {
            if (shelfElement.isFloorElement === true) {
                shelfFloorElements.push(shelfElement);
            }
        });
        return of(shelfFloorElements);
    }

    getNonFloorShelfElements(): Observable<ShelfElement[]> {
        const shelfNonFloorElements = [];
        SHELF_ELEMENTS.forEach(function (shelfElement) {
            if (!(shelfElement.isFloorElement === true)) {
              shelfNonFloorElements.push(shelfElement);
            }
        });
        return of(shelfNonFloorElements);
    }

    getStandardShelfElements(): Observable<ShelfElement[]> {
        const shelfStandardElements = [];
        SHELF_ELEMENTS.forEach(function (shelfElement) {
            if (!(shelfElement.isFloorElement === true) && !(shelfElement.isTopElement === true)) {
              shelfStandardElements.push(shelfElement);
            }
        });
        return of(shelfStandardElements);
    }

    getTopShelfElements(): Observable<ShelfElement[]> {
        const shelfTopElements = [];
        SHELF_ELEMENTS.forEach(function (shelfElement) {
            if (shelfElement.isTopElement === true) {
              shelfTopElements.push(shelfElement);
            }
        });
        return of(shelfTopElements);
    }

}



// WEBPACK FOOTER //
// ./src/app/shelf-element.service.ts